export default __webpack_public_path__ + "static/media/recheck.032c4682.svg";